import { getIsAnyLinePriced } from 'utils/getIsAnyLinePriced';
import { ReloadPricingSummaryArgs } from './campaignPostSaveRefresh.types';

export const reloadPricingSummary = async ({
  settings,
  campaign,
  marketId,
  handlePricedSolution,
}: ReloadPricingSummaryArgs): Promise<void> => {
  const { pricingSolution } = campaign.campaign.body;
  const shouldReloadPricingSummary =
    settings.pricingSummary === 'always' ||
    (settings.pricingSummary === 'whenLinePriced' && !!pricingSolution && getIsAnyLinePriced(campaign.lines));

  if (!shouldReloadPricingSummary) return;

  await handlePricedSolution({
    campaignId: campaign.id,
    marketId,
    pricingSolution: pricingSolution ?? null,
    lines: campaign.lines,
  });
};
